import { useState, useEffect, useMemo, useRef } from 'react'
import useWebSocket, { ReadyState } from 'react-use-websocket'
import { configuration } from 'src/config'
// import api from 'src/utils/api'
import { alog } from 'src/utils/apioLog'

// Hook che salva in un array gli ultimi 2 eventi ricevuti in websocket
const useSocket = (newUrl, userId) => {
  // const [latestMessage, setLatestEvent] = useState({})
  // const [previousEvent, setPreviousEvent] = useState({})
  const [socketUrl, setSocketUrl] = useState(newUrl || configuration.webSocket)
  const messageHistory = useRef([])

  // prefispongo la socket e mi prendo le variabili che mi servono
  const {
    sendMessage,
    lastMessage,
    readyState
  } = useWebSocket(socketUrl, {
    // onOpen: () => alog('socket opened', '', 'socket'),
    // onClose: () => alog('socket closed', '', 'socket'),
    queryParams: {
      userId: userId || ''
    },
    filter: (message) => {
      // alog('new message before filter', message, 'socket')
      const thisEvent = JSON.parse(message.data)
      if (thisEvent && thisEvent.type) {
        return thisEvent.type === 'venera.anomaly.created' || thisEvent.type === 'venera.anomaly.closed'
      } else {
        return false
      }
    },
    // Will attempt to reconnect on all close events, such as server shutting down
    shouldReconnect: (closeEvent) => true
  })

  messageHistory.current = useMemo(() => {
    // return lastMessage ? messageHistory.current.concat(lastMessage) : messageHistory.current
    return lastMessage ? [lastMessage, ...messageHistory.current] : messageHistory.current
  }, [lastMessage])
  // variabile con lo stato della socket in modo leggibile
  const connectionStatus = {
    [ReadyState.CONNECTING]: 'Connecting',
    [ReadyState.OPEN]: 'Open',
    [ReadyState.CLOSING]: 'Closing',
    [ReadyState.CLOSED]: 'Closed',
    [ReadyState.UNINSTANTIATED]: 'Uninstantiated'
  }[readyState]

  // faccio la connessione ed il ping al cambio dell'url
  useEffect(() => {
    if (newUrl !== socketUrl) {
      setSocketUrl(newUrl)
    }
    const pingInterval = setInterval(() => {
      alog('ping socket')
      if (connectionStatus === 'Open') {
        sendMessage('HODORRRR')
      }
    }, 29000)
    return () => {
      clearInterval(pingInterval)
    }
  }, [newUrl, socketUrl, connectionStatus, sendMessage])

  // alog('connectionStatus =>', connectionStatus, 'socket')
  // alog('readyState =>', readyState, 'socket')
  // alog('lastMessage =>', lastMessage, 'socket')
  // alog('messageHistory =>', messageHistory, 'socket')

  // useEffect(() => {
  //   validateToken()
  // }, [validateToken])

  return { connectionStatus, lastMessage, messageHistory }
}

export default useSocket
